class AnaglyphAnimation {
  constructor() {
    if (typeof THREE === 'undefined') {
      return;
    }

    this.container = document.getElementById('anaglyph-container');
    this.settings = JSON.parse(this.container.getAttribute('data-settings'));
    
    this.camera = null;
    this.scene = null;
    this.renderer = null;
    this.effect = null;
    this.spheres = [];
    
    this.mouseX = 0;
    this.mouseY = 0;
    this.windowHalfX = window.innerWidth / 2;
    this.windowHalfY = window.innerHeight / 2;
    this.imageRatio = 500;

    this.init();
  }

  init() {
    if (!this.container) {
      console.error('Container not found');
      return;
    }

    this.setupRenderer();
    this.setupCamera();
    this.setupScene();
    this.setupLights();
    this.createSpheres();
    this.setupEffect();
    this.setupEventListeners();
    this.animate();
    this.loadBackgroundImage();
  }

  setupRenderer() {
    this.renderer = new THREE.WebGLRenderer({ antialias: true });
    this.renderer.setPixelRatio(window.devicePixelRatio);
    this.renderer.setSize(window.innerWidth, window.innerHeight);
    this.renderer.domElement.style.width = '100%';
    this.container.appendChild(this.renderer.domElement);
  }

  setupCamera() {
    this.camera = new THREE.PerspectiveCamera(60, window.innerWidth / window.innerHeight, 0.01, 100);
    this.camera.position.z = this.settings.camera_distance;
  }

  setupScene() {
    this.scene = new THREE.Scene();
    this.scene.background = new THREE.Color(parseInt(this.settings.background_color.replace('#', '0x')));
  }

  setupLights() {
    const ambientLight = new THREE.AmbientLight(0xffffff);
    this.scene.add(ambientLight);

    const pointLight = new THREE.PointLight(0xffffff, 1);
    pointLight.position.set(5, 5, 5);
    this.scene.add(pointLight);
  }

  createSpheres() {
    const geometry = new THREE.SphereGeometry(this.settings.sphere_radius / 10, 32, 16);
    const material = new THREE.MeshPhongMaterial({ 
      color: parseInt(this.settings.sphere_color.replace('#', '0x')),
      shininess: 40,
      specular: 0xffffff
    });

    for (let i = 0; i < this.settings.sphere_count; i++) {
      const mesh = new THREE.Mesh(geometry, material);
      mesh.position.x = Math.random() * 10 - 5;
      mesh.position.y = Math.random() * 10 - 5;
      mesh.position.z = Math.random() * 10 - 5;
      mesh.scale.x = mesh.scale.y = mesh.scale.z = Math.random() * 3 + 1;
      this.scene.add(mesh);
      this.spheres.push(mesh);
    }
  }

  setupEffect() {
    this.effect = new THREE.AnaglyphEffect(this.renderer);
    this.effect.setSize(window.innerWidth, window.innerHeight);
  }

  setupEventListeners() {
    document.addEventListener('mousemove', this.onDocumentMouseMove.bind(this));
    window.addEventListener('resize', this.onWindowResize.bind(this));
  }

  loadBackgroundImage() {
    const info = document.getElementById('info');
    const img = new Image();
    img.src = this.settings.background_image;
    
    img.onload = () => {
      this.imageRatio = img.height / img.width;
      this.updateDimensions();
    }
  }

  updateDimensions() {
    const info = document.getElementById('info');
    const canvas = this.renderer.domElement;
    
    const containerWidth = this.container.offsetWidth;
    const containerHeight = Math.floor(containerWidth * this.imageRatio);
    
    this.container.style.height = containerHeight + 'px';
    info.style.height = containerHeight + 'px';
    
    const canvasAspect = window.innerWidth / window.innerHeight;
    canvas.style.width = '100%';
    canvas.style.height = (containerWidth / canvasAspect) + 'px';
    
    this.camera.aspect = canvasAspect;
    this.camera.updateProjectionMatrix();
    this.renderer.setSize(containerWidth, containerWidth / canvasAspect);
    this.effect.setSize(containerWidth, containerWidth / canvasAspect);
  }

  onWindowResize() {
    this.windowHalfX = window.innerWidth / 2;
    this.windowHalfY = window.innerHeight / 2;
    this.updateDimensions();
  }

  onDocumentMouseMove(event) {
    this.mouseX = (event.clientX - this.windowHalfX) / 100;
    this.mouseY = (event.clientY - this.windowHalfY) / 100;
  }

  animate() {
    requestAnimationFrame(this.animate.bind(this));
    this.render();
  }

  render() {
    const timer = 0.0001 * Date.now();

    this.camera.position.x += (this.mouseX - this.camera.position.x) * .05;
    this.camera.position.y += (-this.mouseY - this.camera.position.y) * .05;

    this.camera.lookAt(this.scene.position);

    for (let i = 0, il = this.spheres.length; i < il; i++) {
      const sphere = this.spheres[i];
      sphere.position.x = 5 * Math.cos(timer + i);
      sphere.position.y = 5 * Math.sin(timer + i * 1.1);
    }

    this.renderer.render(this.scene, this.camera);
  }
}

window.addEventListener('load', () => {
  new AnaglyphAnimation();
});